import React, { useEffect, useState, useRef } from "react";
// import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
// import "./datatables.scss";
// import "../Icons/IconFontawesome";

import Utils from "../Utility";
import { post, get, put, upload } from "../../helpers/api_helper";
import DeleteModal from "./DeleteModal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import "./style.css";

const Table = (props) => {
  const { user, role, currentData, from, setCurrentData, path, setLoading } =
    props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [file, setFile] = useState(null);
  const [img, setImg] = useState(null);
  const imageInput = useRef(null);
  const imageToCrop = useRef(null);
  const cropper = useRef(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [isNavigate, setIsNavigate] = useState("");
  const [navigationType, setNavigationType] = useState("");
  const [screens, setScreens] = useState([]);

  useEffect(() => {
    // console.log('props on user table', props)
    if (user) {
      getData();
    }
  }, [user, path]);

  const getData = () => {
    let url = "/banner/list";
    get(url, { token: user?.token })
      .then((json) => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log("error while getting project list", error);
      });
    get("/screen/list", { token: user?.token }).then((res) => {
      if (res?.statusCode == 200) setScreens(res?.data);
    });
  };

  useEffect(() => {
    setColumns([
      {
        name: "Image",
        cell: (row) => (
          <>
            <img
              title={"image"}
              src={row?.image}
              style={{
                width: 100,
                height: "auto",
                marginTop: 5,
                marginBottom: 5,
              }}
            />
          </>
        ),
      },
      {
        name: "Link Type",
        selector: (row) => row?.linkType,
      },
      {
        name: "Product",
        selector: (row) =>
          row?.linkType == "card" ? row?.card[0]?.name : row?.loan[0]?.name,
      },
      {
        cell: (row) => (
          <>
            <Button
              onClick={() => handleUpdateStatus(row)}
              title={row?.isActive ? "Inactive" : "Active"}
              style={{
                backgroundColor: !row.isActive ? "red" : "green",
                marginRight: 10,
                padding: 5,
                paddingLeft: 8,
                paddingRight: 8,
              }}
            >
              <span className="text-white" style={{}}>
                {!row?.isActive ? "Inactive" : "Active"}
              </span>
            </Button>
          </>
        ),
        name: "Status",
        ignoreRowClick: true,
      },
      {
        cell: (row) => (
          <>
            {/* <Button onClick={() => props?.history.push(`/user/detail/` + row?._id, { state: { type: path } })}
            title={"View in details"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button> */}
            {from != "Dashboard" && (
              <>
                <Button
                  onClick={() => handleUpdateProj(row)}
                  title={"Edit"}
                  style={{
                    backgroundColor: user?.company?.theme
                      ? user?.company?.theme
                      : Utils.themeColor,
                    marginRight: 10,
                    padding: 5,
                    paddingLeft: 8,
                    paddingRight: 8,
                  }}
                >
                  <span
                    className="mdi mdi-pencil"
                    style={{ fontSize: 20 }}
                  ></span>
                </Button>
                <Button
                  onClick={() => handleDeleteProj(row)}
                  title={"Delete"}
                  style={{
                    backgroundColor: user?.company?.theme
                      ? user?.company?.theme
                      : Utils.themeColor,
                    marginRight: 10,
                    padding: 5,
                    paddingLeft: 8,
                    paddingRight: 8,
                  }}
                >
                  <span
                    className="mdi mdi-delete"
                    style={{ fontSize: 20 }}
                  ></span>
                </Button>
              </>
            )}
          </>
        ),
        name: "Action",
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ]);
  }, [data]);

  const handleUpdateProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData(proj);
    setFile(proj?.image);
    setImg(proj?.image);
    setIsNavigate(proj?.isNavigate);
    setNavigationType(proj?.navigationType);
    setIsAddForm(true);
  };

  const handleUpdateStatus = (item) => {
    console.log("updating proj", item);
    setCurrentData({ ...item, actionType: "Status" });
    setDeleteModal(true);
  };

  const handleDeleteProj = (proj) => {
    console.log("updating proj", proj);
    props?.setCurrentData({ ...proj, actionType: "Delete" });
    setDeleteModal(true);
  };

  const onDelete = () => {
    console.log("deleted", currentData);
    let body = {
      bannerId: currentData?._id,
      token: user?.token,
    };
    let url = "/banner/update";
    if (currentData?.actionType == "Status") {
      body = { ...body, isActive: !currentData?.isActive };
    } else {
      body = { ...body, isDeleted: true };
    }
    put(url, body)
      .then((json) => {
        console.log("response from on click action", json);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          props?.setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch((error) => {
        console.error("error while deleting user", error);
      });
  };

  const onChangeFile = async (e) => {
    // console.log(e.target.files[0]);
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1800,
        600,
        "webp",
        60,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const handleValidSubmit = async (e, v) => {
    if (currentData) {
      let image = img;
      if (file.substring(0, 4) == "blob") {
        setLoading(true);
        const fileData = cropper?.current?.cropper
          ?.getCroppedCanvas()
          .toDataURL();
        const obj = await urltoFile(
          fileData,
          new Date().getTime() + ".png",
          "image/png"
        );
        const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", temp);
        const imageRes = await upload("/banner/image_upload", form);
        image = imageRes?.data;
      }
      const body = {
        ...v,
        token: user?.token,
        image,
        bannerId: currentData?._id,
      };
      put("/banner/update", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            getData();
            toast.success(res?.message);
            setCurrentData(null);
            setFile(null);
            setIsNavigate("");
            setImg("");
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("error while updating banner", error);
        });
    } else {
      if (file) {
        let image = "";
        setLoading(true);
        const fileData = cropper?.current?.cropper
          ?.getCroppedCanvas()
          .toDataURL();
        const obj = await urltoFile(
          fileData,
          new Date().getTime() + ".png",
          "image/png"
        );
        const temp = await resizeFile(obj);
        const form = new FormData();
        form.append("image", temp);
        const imageRes = await upload("/banner/image_upload", form);
        image = imageRes?.data;
        const body = {
          ...v,
          image,
          token: user?.token,
        };
        post("/banner/add", body)
          .then((res) => {
            setLoading(false);
            if (res?.statusCode == 200) {
              toast.success(res?.messgae);
              setIsAddForm(false);
              getData();
            } else {
              toast.error(res?.error);
            }
          })
          .catch((error) => {
            setLoading(false);
            toast.error("Something Went Wrong!");
            console.log("error while adding banner", error);
          });
      } else toast.error("Please choose a banner image!");
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
          />
          <Modal
            isOpen={isAddForm}
            toggle={() => setIsAddForm(!isAddForm)}
            centered={true}
            style={{ maxWidth: 540 }}
          >
            <ModalBody>
              <div className="me-3 position-relative">
                {file ? (
                  <>
                    {img ? (
                      <>
                        <img
                          src={img}
                          alt=""
                          style={{ width: 360, height: "auto" }}
                          // onClick={(e) => imageInput.current.click(e)}
                        />
                        <div
                          style={{
                            position: "absolute",
                            height: 40,
                            width: 40,
                            right: -10,
                            top: -8,
                            paddingTop: 5,
                            backgroundColor: Utils.themeColor,
                            borderRadius: 50,
                            textAlignLast: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setFile(null);
                            setImg("");
                          }}
                        >
                          <i
                            className="mdi mdi-close"
                            style={{ color: "white", fontSize: 22 }}
                          />
                        </div>
                      </>
                    ) : (
                      <Cropper
                        style={{ height: "auto", width: 500 }}
                        aspectRatio={512 / 256}
                        preview=".img-preview"
                        guides={true}
                        src={file}
                        ref={cropper}
                      />
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      position: "relative",
                      width: 500,
                      height: 320,
                      border: "1px dashed " + Utils.themeColor,
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: Utils.themeColor,
                      fontSize: 22,
                    }}
                    onClick={(e) => imageInput.current.click(e)}
                  >
                    <span
                      style={{
                        padding: 5,
                        paddingLeft: 15,
                        paddingRight: 15,
                        border: "1px solid " + Utils.themeColor,
                        borderRadius: 5,
                      }}
                    >
                      Choose Image
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        height: 40,
                        width: 40,
                        right: -10,
                        top: -8,
                        paddingTop: 5,
                        backgroundColor: Utils.themeColor,
                        borderRadius: 50,
                        textAlignLast: "center",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="mdi mdi-camera-outline"
                        style={{ color: "white", fontSize: 22 }}
                      />
                    </div>
                  </div>
                )}
                <input
                  type="file"
                  id="file"
                  ref={imageInput}
                  onChange={onChangeFile}
                  style={{ display: "none" }}
                />
                <AvForm
                  className="form-horizontal mt-4"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v);
                  }}
                >
                  <Row>
                    <Col lg={6} md={6}>
                      <div className="form-group mb-4">
                        <AvField
                          name="bannerName"
                          label="Name"
                          value={currentData?.bannerName}
                          className="form-control"
                          type="text"
                          required
                        >
                          {/* <option value="">Select Navigation</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option> */}
                        </AvField>
                      </div>
                      <div className="form-group mb-4">
                        <AvField
                          name="isNavigate"
                          label={"Status"}
                          value={isNavigate}
                          className="form-control"
                          type="select"
                          required
                          onChange={(e) => setIsNavigate(e.target.value)}
                        >
                          <option value="">Select Status</option>
                          <option value="Yes">Active</option>
                          <option value="No">Inactive</option>
                        </AvField>
                      </div>
                    </Col>
                    {isNavigate == "Yes" && (
                      <Col lg={6} md={6}>
                        <div className="form-group mb-4">
                          <AvField
                            name="navigationType"
                            label={"Select Navigation Type"}
                            value={currentData?.navigationType}
                            className="form-control"
                            type="select"
                            onChange={(e) => setNavigationType(e.target.value)}
                            required
                          >
                            <option value="">Select Navigation Type</option>
                            <option value="internalPage">
                              Internal App Screen
                            </option>
                            <option value="inApp">In App Link</option>
                            <option value="outApp">External Web Link</option>
                          </AvField>
                        </div>
                      </Col>
                    )}
                    {isNavigate == "Yes" && (
                      <>
                        {navigationType == "internalPage" ? (
                          <Col lg={6} md={6}>
                            <div className="form-group mb-4">
                              <AvField
                                name="screenName"
                                label={"Select Navigation Type"}
                                value={currentData?.screenName}
                                className="form-control"
                                type="select"
                                required
                              >
                                <option value="">Select App Screen</option>
                                {screens?.map((item) => (
                                  <option value={item?.for}>
                                    {item?.title}
                                  </option>
                                ))}
                              </AvField>
                            </div>
                          </Col>
                        ) : (
                          <Col lg={12} md={12}>
                            <div className="form-group mb-4">
                              <AvField
                                name="link"
                                label={"Web URL"}
                                value={currentData?.link}
                                className="form-control"
                                placeholder={`Enter Url you need to open`}
                                type="url"
                                required
                              />
                            </div>
                          </Col>
                        )}
                      </>
                    )}
                    <div className="text-center mt-4">
                      {currentData ? (
                        <Button
                          type="submit"
                          color="primary"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          Update Banner
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          color="primary"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Row>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div
                  className="d-flex"
                  style={{ marginLeft: "auto", marginBottom: 30 }}
                >
                  <div>
                    {/* <CardTitle className="h4">{props.role}</CardTitle> */}
                    {/* <CardSubtitle className="mb-3"> */}
                    {role} Add banner to Click Button<code>{role} </code>{" "}
                    <code></code>
                    {/* </CardSubtitle> */}
                  </div>
                  <div className="text-center" style={{ marginLeft: "auto" }}>
                    <Button
                      style={{
                        backgroundColor: Utils.themeColor,
                        border: "none",
                      }}
                      onClick={() => setIsAddForm(true)}
                    >
                      Add
                    </Button>
                  </div>
                </div>
                <Row>
                  {data?.map((item, index) => (
                    <Col lg={4} className="banner">
                      <img
                        src={item?.image}
                        style={{ width: 350, height: 175 }}
                      />
                      <div
                        className="contain1"
                        style={{
                          backgroundColor: Utils.themeColor + "88",
                          padding: 20,
                          position: "absolute",
                          top: 0,
                          color: "white",
                          flexDirection: "column",
                          display: "flex",
                        }}
                      >
                        <p>Is Navigate : {item?.isNavigate}</p>
                        {item?.navigationType && (
                          <p>Navigation Type : {item?.navigationType}</p>
                        )}
                        {item?.screenName && (
                          <p>Screen Name : {item?.screenName}</p>
                        )}
                        {item?.link && <p>Link : {item?.link}</p>}
                      </div>
                      <div
                        className="contain2"
                        style={{
                          backgroundColor: Utils.themeColor + "88",
                          padding: 10,
                          position: "absolute",
                          top: 0,
                          right: 0,
                          color: "white",
                          flexDirection: "column",
                          display: "flex",
                        }}
                      >
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "white",
                            fontSize: 20,
                            cursor: "pointer",
                          }}
                          onClick={() => handleUpdateProj(item)}
                        />
                        <i
                          className="mdi mdi-delete"
                          style={{
                            color: "white",
                            fontSize: 20,
                            marginTop: 5,
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteProj(item)}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};
export default Table;
